import React, { useRef } from "react";
import SearchBar from "../SearchBar"; // adjust the path as needed
import ProductCard from "../ProductCard"; // adjust the path based on your folder structure
import CategoryMetaForm from "./CategoryMetaForm";
const CategoriesManager = ({
    categories,
    newCategory,
    newCategoryImage,
    newMetaTitle,
    newMetaDescription,
    newMetaKeywords,
    searchTerm,
    filteredCategories,
    setNewCategory,
    setNewCategoryImage,
    setNewMetaTitle,
    setNewMetaDescription,
    setNewMetaKeywords,
    handleSearchChange,
    handleSuggestionClick,
    handleAddImageChange,
    addCategory,
    editCategory,
    deleteCategory,
    setEditingImageIndex,
    imageEditInputRef,
    cardConfig, // global card config passed from AdminPanel
}) => {
    // Create a dedicated ref for the new category image input
    const newCategoryImageRef = useRef(null);

    // New handler: when the image container is clicked, trigger the input click via the ref
    const handleNewCategoryImageClick = () => {
        if (newCategoryImageRef.current) {
            newCategoryImageRef.current.click();
        }
    };

    return (
        <>

            <div className="content-header">
                <h2>Manage Categories</h2>
                <SearchBar
                    searchTerm={searchTerm}
                    onSearchChange={handleSearchChange}
                    suggestions={filteredCategories.map((cat) => cat.category)}
                    onSuggestionClick={handleSuggestionClick}
                    placeholder="Search category..."
                />
            </div>

            {/* Add New Category Card */}
            <div
                style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "flex-start", // Aligns the tops of both elements
                }}
            >
                <CategoryMetaForm />
                <div className="add-category-card">
                    <div className="image-container" onClick={handleNewCategoryImageClick}>
                        {newCategoryImage ? (
                            <img
                                src={URL.createObjectURL(newCategoryImage)}
                                alt="Preview"
                                className="category-preview"
                            />
                        ) : (
                            <div className="plus-symbol">+</div>
                        )}
                        <input
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handleAddImageChange}
                            ref={newCategoryImageRef}
                        />
                    </div>
                    <input
                        type="text"
                        placeholder="Category Name"
                        value={newCategory}
                        onChange={(e) => setNewCategory(e.target.value)}
                        className="category-name-input"
                    />
                    <input
                        type="text"
                        placeholder="Meta Title"
                        value={newMetaTitle}
                        onChange={(e) => setNewMetaTitle(e.target.value)}
                        className="category-name-input"
                    />
                    <textarea
                        placeholder="Meta Description"
                        value={newMetaDescription}
                        onChange={(e) => setNewMetaDescription(e.target.value)}
                        className="category-name-input"
                    />
                    <input
                        type="text"
                        placeholder="Meta Keywords (comma separated)"
                        value={newMetaKeywords}
                        onChange={(e) => setNewMetaKeywords(e.target.value)}
                        className="category-name-input"
                    />
                    <button onClick={addCategory} className="create-category-button">
                        Create Category
                    </button>
                </div>


            </div>

            {/* Categories List rendered as generic Product Cards */}
            <div className="categories-list">
                {categories.map((cat, index) => (
                    <ProductCard
                        key={cat.id || index}
                        productId={cat.id} // Pass the unique identifier here
                        title={cat.category}
                        description={cat.description || ""}
                        price={cat.price || ""}
                        discount={cat.discount || ""}
                        rating={cat.rating || ""}
                        mediaUrl={
                            cat.categoryUrl ||
                            "https://via.placeholder.com/300x200" // placeholder if no image provided
                        }
                        mediaType="image"
                        // Pass SEO data to ProductCard (won't display in view mode)
                        metaTitle={cat.seo?.metaTitle || ""}
                        metaDescription={cat.seo?.metaDescription || ""}
                        metaKeywords={cat.seo?.metaKeywords || ""}
                        edit={true}      // allow editing of image and text fields
                        editTitle={true} // allow inline editing of text fields
                        onEdit={() => {
                            setEditingImageIndex(index);
                            if (imageEditInputRef.current) {
                                imageEditInputRef.current.click();
                            }
                        }}
                        onSave={(updatedData) => {
                            // updatedData now contains title, description, price, discount, rating,
                            // along with SEO fields (metaTitle, metaDescription, metaKeywords)
                            editCategory(index, updatedData);
                        }}
                        onDelete={() => deleteCategory(index)}
                        cardsPerRow={5}
                        cardsPerRowPhoneView={2}
                    />
                ))}
            </div>
        </>
    );
};

export default CategoriesManager;
